import { CircularProgress } from "@mui/material";
import React from "react";
import { colors } from "../../utils/constants";

interface ButtonPropType {
  text: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  width?: "fit" | "full";
  variant?: "Primary" | "Secondary" | "Outlined" | "Tertiary" | "loading" | "Green" | "orange";
  name?: string;
  noBackgroundColor?: boolean;
  hover?: boolean;
  verified?: boolean;
  icon?: React.ReactNode;
  buttonStyle?: "rounded" | "square";
}

const Button = ({
  text = "Button",
  onClick = () => {},
  className = "",
  disabled = false,
  width = "full",
  variant = "Primary",
  name = "",
  noBackgroundColor = false,
  verified = false,
  icon,
  buttonStyle = "rounded",
}: ButtonPropType) => {
  let buttonColor = verified
    ? "bg-docnote-lilac hover:bg-docnote-lilac-dark hover:text-white border-docnote-lilac"
    : "bg-docnote-orange hover:bg-white hover:text-docnote-orange border-docnote-orange";

  switch (variant) {
    case "Primary":
    case "loading":
      buttonColor = noBackgroundColor ? "text-white" : `text-white ${buttonColor}`;
      break;
    case "Secondary":
      buttonColor = "border text-white border-docnote-purple-grey bg-docnote-purple-grey hover:bg-white hover:text-docnote-purple-grey";
      break;
    case "Outlined":
      buttonColor = "border text-docnote-orange border-docnote-orange bg-transparent";
      break;
    case "Tertiary":
      buttonColor = "border border-black-10 bg-transparent text-[#0A0A0A]";
      break;
    case "Green":
      buttonColor = "border text-black border-docnote-green bg-docnote-green hover:bg-white hover:bg-transparent";
      break;
    case "orange":
      buttonColor = "border text-white border-[#fb5b30] bg-[#fb5b30] hover:bg-white hover:text-[#fb5b30] hover:bg-transparent";
      break;
    default:
      break;
  }

  const shapeStyles = buttonStyle === "square" ? "rounded-lg h-12" : "rounded-full";

  const buttonStyles = `${className} ${
    width === "full" ? "w-full" : ""
  } text-sm text-center px-5 py-2.5 font-semibold leading-none ${shapeStyles} border shadow-none outline-none transition duration-500 ${buttonColor}`;

  return (
    <div style={{ position: "relative" }}>
      {variant === "loading" ? (
        <div
          style={{
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <CircularProgress size="1.5rem" sx={{ color: colors.Orange }} />
        </div>
      ) : null}
      <button
        name={name}
        onClick={!disabled && variant !== "loading" ? onClick : () => {}}
        className={buttonStyles}
        style={disabled || variant === "loading" ? { opacity: "37%" } : {}}
      >
        {icon ?? null}
        {text}
      </button>
    </div>
  );
};

export default Button;
